import { render, staticRenderFns } from "./tuantiform.vue?vue&type=template&id=48bd6410&scoped=true&"
import script from "./tuantiform.vue?vue&type=script&lang=js&"
export * from "./tuantiform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bd6410",
  null
  
)

export default component.exports